import { render, staticRenderFns } from "./TransferLabel.vue?vue&type=template&id=66f05f2f"
import script from "./TransferLabel.vue?vue&type=script&lang=js"
export * from "./TransferLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports